import ReactApexChart from 'react-apexcharts';

const MonthlyNewUsersChart = ({ monthWiseData = [] }) => {
  const months = monthWiseData.map(item => item.MonthName || `Month ${item.MonthNo}`);
  const farmerCounts = monthWiseData.map(item => item.FarmerCount || 0);

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: months,
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " farmers";
        }
      }
    },
    colors: ['#4CAF50', '#81C784'],
  };

  const chartSeries = [
    {
      name: 'New Farmers',
      data: farmerCounts
    }
  ];

  return (
    <div className="col-xxl-6 col-xl-12">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <h6 className="text-lg mb-0" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
              Monthly New Farmers
            </h6>
            <div style={{ width: 'auto' }}></div>
          </div>
          
          <ReactApexChart 
            options={chartOptions} 
            series={chartSeries} 
            type="bar"
            height={350} 
          />
        </div>
      </div>
    </div>
  );
};

export default MonthlyNewUsersChart;